export default {
    data() {
        return {
            // 课程分类名称
            categoryName: '',
            // 课程分类年份
            year: '',
            // 课程年份数组
            years: [],
            // 是否显示对话框
            dialogVisible: false,
            // 对话框标题
            message: '',
            // 添加/修改的课程分类名称
            activeCategoryName: '',
            // 添加/修改的课程分类年份
            activeYear: '',
            // 添加/修改的课程分类学时
            activePeriod: '',
            // 点击的是添加课程分类还是修改课程分类， flag为1，表示是添加
            flag: '',
            // 每页显示条数
            pageSize: 15,
            // 当前页
            currentPage: 1,
            // 总条数
            total: 0,
            // 课程类别数据
            list: [],
            // 当前的课程分类id
            id: '',
            // 是否显示添加课程产品的对话框
            addDialog: false,
            // 课程产品数据
            productList: [],
            // 需要添加课程数组
            product: [],
            // 是否显示已添加产品的对话框
            showDialog: false,
            // 穿梭框加载状态
            addLoading: true,
            // 已添加的产品数组
            addedProductList: [],
            // 是否显示添加试题资源的弹窗
            showExamResources: false,
            // 试题数组
            resourceList: [],
            // 加载资源时显示加载效果
            loadResources: false,
            // 选择的资源id
            resourceId: '',
            // 已添加到套餐的资源
            addedResource: '',
            // 上传的地址
            action: this.baseUrl + 'product_category/upload',
            // 下载的模板路径
            // download: this.baseUrl + 'excel_template/category.zip'
            download: 'https://zzpt.ca163.net/excel_template/category.zip',
            // 上传返回弹窗
            msgDialogVisible: false,
            uploadMsg:[]
        }
    },

    methods: {
        // 获取课程分类
        search() {
            this.currentPage = 1;
            this.getData();
        },

        // 显示对话框
        showAddDialog() {
            // 点击的是添加课程分类的对话框
            this.flag = 1;
            this.message = '添加课程分类';
            this.dialogVisible = true;
        },

        // 处理点击添加/修改课程分类
        handleClick() {
            // 验证内容是否为空
            if (this.$isAbnormal(this.activeCategoryName)) {
                this.$message({
                    type: 'error',
                    message: '请输入课程分类名称'
                });
                return;
            }
            if (this.$isAbnormal(this.activeYear)) {
                this.$message({
                    type: 'error',
                    message: '请输入课程分类年份'
                });
                return;
            }

            if (this.flag === 1) {
                this.insertProductCategory();
            } else {
                this.updateProductCategory();
            }
        },


        insertProductCategory() {
            this.$post('product_category/insert', {
                token: this.$store.state.authority_management,
                name: this.activeCategoryName.trim(),
                year: this.activeYear.trim(),
                shop_id: this.$store.state.store.id
            }).then(res => {
                this.handleResponse(res);
            })
        },

        updateProductCategory() {
            this.$post('product_category/update', {
                token: this.$store.state.authority_management,
                id: this.id,
                name: this.activeCategoryName.trim(),
                year: this.activeYear.trim(),
                period: this.activePeriod.trim(),
            }).then(res => {
                this.handleResponse(res);
            })
        },

        // 处理响应
        handleResponse(res) {
            if (res.data.status === 'success') {
                this.$message({
                    type: 'success',
                    message: '操作成功'
                });
            } else {
                this.$message({
                    type: 'error',
                    message: '操作失败，请稍后重试'
                });
            }
            this.getData();
            this.activeCategoryName = '';
            this.activeYear = ''
            this.flag = '';
            this.dialogVisible = false;
        },

        // 处理获得年份数组
        handleYears(array) {
            let years = [];
            for (let item of array) {
                years.push({
                    value: item.year,
                    label: item.year
                });
            }

            // 去掉数组中重复的对象
            this.years = this.deteleObject(years)
        },

        // 每页显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.getData();
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
            this.getData();
        },

        // 去除数组中的重复对象
        deteleObject(obj) {
            var uniques = [];
            var stringify = {};
            for (var i = 0; i < obj.length; i++) {
                var keys = Object.keys(obj[i]);
                keys.sort(function (a, b) {
                    return (Number(a) - Number(b));
                });
                var str = '';
                for (var j = 0; j < keys.length; j++) {
                    str += JSON.stringify(keys[j]);
                    str += JSON.stringify(obj[i][keys[j]]);
                }
                if (!stringify.hasOwnProperty(str)) {
                    uniques.push(obj[i]);
                    stringify[str] = true;
                }
            }
            // uniques = uniques;
            return uniques;
        },

        // 显示修改的对话框并赋值
        edit(category) {
            this.id = category.id;
            this.activeCategoryName = category.name;
            this.activeYear = category.year;
            this.activePeriod = category.period;
            this.flag = 2;
            this.message = '修改课程分类';
            this.dialogVisible = true;  
        },

        // 显示添加课程产品的对话框
        add(id) {
            this.id = id;
            this.addDialog = true;
            // 获取课程产品
            this.getAllProduct();
        },

        // 获取所有课程
        getAllProduct() {
            this.$post('products/search', {
                shop_id: this.$store.state.store.id,
                offset: 0,
                length: 9999
            }).then(res => {
                this.handleProductList(res.data.result.data);
            });
        },

        // 处理课程数组
        handleProductList(list) {
            let productList = [];
            list.forEach(item => {
                let obj = {};
                obj.key = item.id;
                obj.label = item.name;
                productList.push(obj);
            });
            this.productList = productList;

            // 取消穿梭框加载状态
            this.addLoading = false;
        },

        // 添加课程
        addProduct() {
            let promises = this.product.map(product_id => {
                return this.$post('product_category_mapping/insert', {
                    token: this.$store.state.authority_management,
                    category_id: this.id,
                    product_id: product_id
                });
            });

            Promise.all(promises).then(() => {
                this.$message({
                    type: 'success',
                    message: '添加产品成功'
                })
            }).catch(() => {
                this.$message({
                    type: 'error',
                    message: '添加产品失败'
                })
            });

            this.addDialog = false;
        },

        // 查看课程分类下的课程
        showProducts(id) {
            this.id = id;
            this.showDialog = true
            this.$post('product_category_mapping/search', {
                token: this.$store.state.authority_management,
                category_id: this.id,
                offset: 0,
                length: 999
            }).then(res => {
                this.addedProductList = res.data.result.data;
            })
        },

        // 删除课程分类下的课程
        deleteProduct(id, productName) {
            this.$confirm(`确定删除该课程分类下的 【${productName}】 吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$post('product_category_mapping/delete', {
                    token: this.$store.state.authority_management,
                    id: id
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                    this.showProducts(this.id);
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            })
        },

        // 删除一个课程分类
        deleteCategory(id, categoryName) {
            this.$confirm(`确定删除课程分类 【${categoryName}】 吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$post('product_category/delete', {
                    token: this.$store.state.authority_management,
                    id: id,
                    available: 0
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                    this.getData();
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            })
        },

        // 点击添加试题资源按钮，获取试题资源
        getExamResources(id) {
            this.id = id;
            this.showExamResources = true;
            this.loadResources = true;

            // 获取已添加资源
            this.getAddedResources();

            this.$post('resources/shop_search', {
                token: this.$store.state.authority_management,
                offset: 0,
                length: 9999,
                type: 2
            }).then(res => {
                this.resourceList = res.data.result.data;
                this.loadResources = false;
            })
        },

        // 添加试题资源
        addExamResources() {
            this.$post('product_category/update', {
                token: this.$store.state.authority_management,
                id: this.id,
                resource_id: this.resourceId
            }).then(res => {
                if (res.data.status === 'success') {
                    this.$message.success('操作成功');
                    // 获取已添加资源
                    this.getAddedResources();
                    this.addedResource = '';
                } else {
                    this.$message.error('操作失败，请稍后重试');
                }
            })
        },

        // 获取当前套餐已添加的资源
        getAddedResources() {
            this.$post('product_category/get', {
                token: this.$store.state.authority_management,
                id: this.id
            }).then(res => {
                this.addedResource = res.data.result.resource_name;
            })
        },

        // 获取资源
        getData() {
            this.$post('product_category/search', {
                token: this.$store.state.authority_management,
                name: this.categoryName,
                year: this.year,
                available: 1,
                shop_id: this.$store.state.store.id,
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize
            }).then(res => {
                this.total = res.data.result.total;
                this.list = res.data.result.data;
                // 处理获得年份数组
                this.handleYears(res.data.result.data);
            })
        },

        // 上传
        httpreq(q) {
            this.$upload(this.action, q).then(res => {
                this.uploadMsg = res.data.errorMsg || res.data.result
                this.msgDialogVisible = true
                this.getData();
            })
        },

    },

    created() {
        this.getData();
    },
}